export class GoogleWorkspaceConnectionInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "discoveryServiceAccount",
            "baseName": "discoveryServiceAccount",
            "type": "GoogleWorkspaceServiceAccountInfo",
            "format": ""
        },
        {
            "name": "backupServiceAccount",
            "baseName": "backupServiceAccount",
            "type": "GoogleWorkspaceServiceAccountInfo",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceConnectionInfo.attributeTypeMap;
    }
    constructor() {
    }
}
